import { CardMediaPill } from '@app/components/base/CardMediaPill';
import { defineMessage, useIntl } from 'react-intl';

const editsCountMessage = defineMessage({
  id: 'compose.listCard.editsCount',
  defaultMessage: '{count, plural, one {# edit} other {# edits}}',
});

/**
 * Edits count pill overlaid on composition list card media (top-left).
 * Hidden when there is only one edit (not useful signal).
 */
export function CompositionCardEditsCount({ count }: { count: number }) {
  const { formatMessage: $t } = useIntl();

  if (count <= 1) {
    return null;
  }

  return <CardMediaPill>{$t(editsCountMessage, { count })}</CardMediaPill>;
}
